import { useFetchTable } from '@/domains/investor/composables/useFetchTable'
import type { TTextBox } from '@/domains/investor/components/TextBox/TextBox.types'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import type { IInvestorTab, IInvestorChartConfig } from '@/domains/investor/types/investor.types'

export const useDataPresentationPage = async () => {

  const { t } = useI18n()
  const { fetchTable } = await useFetchTable()

  const updateTabContent = async (tab: IInvestorTab) => {
    if (tab.tableId) {
      const tabIndex = financialDataTabs.value.findIndex(t => t.tableId === tab.tableId)
      if (tabIndex !== -1 && financialDataTabs.value[tabIndex] && !financialDataTabs.value[tabIndex].tableData) {
        const response = await fetchTable(tab.tableId)
        if (financialDataTabs.value[tabIndex]) {
          financialDataTabs.value[tabIndex].tableData = response?.data?.value || null
        }
      }
    }
  }

  const textBoxes: TTextBox[] = [
    {
      title: t('investor.dataPresentations.textBox.operationalData.title'),
      text: t('investor.dataPresentations.textBox.operationalData.text'),
      button: {
        text: t('investor.dataPresentations.textBox.operationalData.button.text'),
        to: t('investor.dataPresentations.textBox.operationalData.button.to'),
      },
    },
    {
      title: t('investor.dataPresentations.textBox.financialData.title'),
      text: t('investor.dataPresentations.textBox.financialData.text'),
      button: {
        text: t('investor.dataPresentations.textBox.financialData.button.text'),
        to: t('investor.dataPresentations.textBox.financialData.button.to'),
      },
    },
  ]

  const financialDataTabs = ref<IInvestorTab[]>(
    [
      {
        label: t('investor.dataPresentations.financialData.tabs[0].label'),
        slotName: 'financial-data-year',
        tableId: 'financial-data',
        tableData: null,
      },
      {
        label: t('investor.dataPresentations.financialData.tabs[1].label'),
        slotName: 'financial-data-quarter',
        tableId: 'financial-data-quarter',
        tableData: null,
      },
    ],
  )

  const chartConfigs: IInvestorChartConfig[] = [
    {
      id: 'rozwoj-liczby-kart-sportowych-w-grupie-benefit-systems',
      sectionId: 'chart-1',
    },
    {
      id: 'rozwoj-liczby-kart-sportowych-na-rynkach-zagranicznych',
      sectionId: 'chart-2',
    },
    {
      id: 'rozwoj-liczby-klubow-fitness-w-grupie-benefit-systems',
      sectionId: 'chart-3',
    },
    {
      id: 'liczba-uzytkownikow-platform-kafeteryjnych-w-grupie-benefit-systems',
      sectionId: 'chart-4',
    },
    {
      id: 'obroty-na-platformach-kafeteryjnych-w-grupie-benefit-systems-w-tys-zl',
      sectionId: 'chart-5',
    },
  ]

  return {
    updateTabContent,
    textBoxes,
    financialDataTabs,
    chartConfigs,
  }
}
